import { uniqBy } from "@s-libs/micro-dash";

import getRelevantWritePromptResponses from "@/view/utils/getRelevantWritePromptResponses";
import pickApplicableWritePrompt from "../pickApplicableWritePrompt";
import promptMatchesCollection from "../promptMatchesCollection";
import promptMatchesTeachers from "../promptMatchesTeachers";

const promptIsCustom = (prompt) => {
  return Boolean(prompt.teacher);
};

const getRelevantWritePrompts = (
  articleId,
  classroom,
  writePrompts,
  writePromptResponses,
  collectionId,
) => {
  // Filter out custom prompts not relevant to the selected classroom.
  const classroomPrompts = writePrompts.filter((prompt) => {
    return (
      !promptIsCustom(prompt) ||
      (classroom?.teachers &&
        promptMatchesTeachers(prompt, classroom?.teachers))
    );
  });

  // Then use the collection to find the most relevant prompt.
  const mostRelevantPrompt = pickApplicableWritePrompt({
    prompts: classroomPrompts,
    collection: { id: collectionId },
  });

  /**
   * Next, find any other prompts from among the fetched prompts that the student has
   * already responded to that should show for the selected collection.
   */
  const additionalRespondedPrompts = writePrompts.filter((prompt) => {
    const isOtherPrompt = prompt.id !== mostRelevantPrompt?.id;
    const promptHasResponses =
      getRelevantWritePromptResponses(
        writePromptResponses,
        articleId,
        prompt.id,
        classroom?.id,
      ).length !== 0;
    const promptShowsForCollection =
      !prompt.collections ||
      promptMatchesCollection(prompt, { id: collectionId });

    return isOtherPrompt && promptHasResponses && promptShowsForCollection;
  });

  return uniqBy(
    [mostRelevantPrompt, ...additionalRespondedPrompts],
    (prompt) => prompt?.id,
  );
};

export default getRelevantWritePrompts;
